<template>
  <div>
    {{ t('chatbot_not_supported_product') }}
  </div>
</template>

<script>
  import { useI36n } from '@jota-one/i36n/src/index.vue2'

  export default {
    name: 'ChatBotNotSupported',

    setup () {
      const { $label: t } = useI36n()

      return { t }
    }
  }
</script>
